/* eslint-disable react/prop-types */
import React from 'react'
import PropTypes from 'prop-types'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import Typography from '@material-ui/core/Typography'
import secureLink from '@utils/secureLink'

const HEADING_VARIANT_BY_LEVEL = {
  h1: 'subtitle1',
  h2: 'subtitle1',
  h3: 'subtitle2',
  h4: 'subtitle2',
  h5: 'body2',
  h6: 'body2',
}

const buildHeading = (tag, component) => function MdHeading({ node, ordered, ...rest }) {
  return (
    <Typography
      {...rest}
      variant={HEADING_VARIANT_BY_LEVEL[tag]}
      component={component}
      gutterBottom={component !== 'span'}
    />
  )
}

function MarkdownText({
  children, className, paragraphVariant, inline,
}) {
  if (!children || typeof children !== 'string') return null

  const paragraphComponent = inline ? 'span' : 'p'
  const headingComponent = inline ? 'span' : 'p'

  return (
    <ReactMarkdown
      className={className}
      skipHtml
      remarkPlugins={[remarkGfm]}
      components={{
        p: ({ node, ordered, ...rest }) => (
          <Typography {...rest} variant={paragraphVariant} component={paragraphComponent} />
        ),
        a: ({
          node, href, children: linkChildren, ...rest
        }) => (
          <a href={secureLink(href)} target="_blank" rel="noopener noreferrer" {...rest}>
            {linkChildren}
          </a>
        ),
        h1: buildHeading('h1', headingComponent),
        h2: buildHeading('h2', headingComponent),
        h3: buildHeading('h3', headingComponent),
        h4: buildHeading('h4', headingComponent),
        h5: buildHeading('h5', headingComponent),
        h6: buildHeading('h6', headingComponent),
        ul: ({ node, ordered, ...rest }) => (
          inline
            ? <span {...rest} />
            : <ul {...rest} style={{ paddingLeft: '1.25em', margin: 0 }} />
        ),
        ol: ({ node, ordered, ...rest }) => (
          inline
            ? <span {...rest} />
            : <ol {...rest} style={{ paddingLeft: '1.25em', margin: 0 }} />
        ),
        li: ({ node, ordered, ...rest }) => (
          inline
            ? <Typography {...rest} variant={paragraphVariant} component="span" />
            : <li><Typography {...rest} variant={paragraphVariant} component="span" /></li>
        ),
      }}
    >
      {children}
    </ReactMarkdown>
  )
}

MarkdownText.propTypes = {
  children: PropTypes.string,
  className: PropTypes.string,
  paragraphVariant: PropTypes.string,
  inline: PropTypes.bool,
}

MarkdownText.defaultProps = {
  children: null,
  className: undefined,
  paragraphVariant: 'body2',
  inline: false,
}

export default MarkdownText
